import { useMemo, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Select from 'components/select';
import FieldDefault from 'components/field-default';

const TypeSelector = ({ value, onChange }) => {
    const { t } = useTranslation('recurring');

    const options = useMemo(() => [
        {
            id: 'dayOfYear',
            text: t('cronTypes.day')
        },
        {
            id: 'dayOfMonth',
            text: t('cronTypes.dayOfMonth')
        },
        {
            id: 'weekOfYear',
            text: t('cronTypes.week')
        },
        {
            id: 'weekOfMonth',
            text: t('cronTypes.weekOfMonth')
        },
        {
            id: 'month',
            text: t('cronTypes.month')
        },
        {
            id: 'year',
            text: t('cronTypes.year')
        }
    ], [t]);

    const type = useRef(value?.type || options[0].id);
    const every = useRef(value?.every || 1);

    const handleEveryBlur = nextEvery => {
        nextEvery = Number(nextEvery) || 1;
        every.current = nextEvery;

        onChange({
            type: type.current,
            every: nextEvery
        });
    }

    const handleTypeChange = ({ id: nextType }) => {
        type.current = nextType;

        onChange({
            type: nextType,
            every: every.current
        }, true);
    }

    useEffect(() => {
        type.current = value?.type || options[0].id;
        every.current = value?.every || 1;
    }, [value]);

    return (
        <div className="resource-repeat-row">
            <div className="row-label">
                { t('Every (period type)') }
            </div>

            <div className="row-value">
                <div className="row-input">
                    <FieldDefault
                        small={true}
                        type="number"
                        min="1"
                        value={value?.every || every.current}
                        onBlur={handleEveryBlur}
                    />
                </div>

                <div className="row-input">
                    <Select
                        small={true}
                        selected={value?.type || type.current}
                        options={options}
                        onChange={handleTypeChange}
                    />
                </div>
            </div>
        </div>
    );
}

export default TypeSelector;
